<template>
    <v-container class="d-flex flex-column align-center justify-center fill-width fill-height">
        <div class="d-flex align-center mb-4">
            <v-btn
                color="#5B951A"
                @click="addFile"
                class="mr-4"
            >
                Добавить файл
            </v-btn>
            <span v-if="selectedFile">{{ selectedFile.name }}</span>
            <span v-else>Файл отсутствует</span>
            <v-btn
                color="red"
                variant="text"
                icon="mdi-delete"
                size="24"
                class="ml-2"
                @click="deleteFile"
                v-if="selectedFile"
            ></v-btn>
        </div>
        <v-btn
            color="#68A91D"
            @click="executeSync"
            :loading="loading"
            :readonly="loading"
            class="mb-4"
        >
            Выполнить синхронизацию аналитики
        </v-btn>
        <v-card v-if="showSyncLog" class="mb-4" outlined elevation="2" style="width: 800px; max-height: 120px; overflow-y: auto;">
            <v-card-text style="font-family: monospace; font-size: 18px;">
                {{ syncLog }}
            </v-card-text>
        </v-card>
        <v-btn
            color="#68A91D"
            @click="downloadLog"
            style="margin-top: 90px;"
            :loading="loading_log"
            :readonly="loading_log"
        >
            Скачать логи
        </v-btn>
    </v-container>
    <input type="file" ref="fileInput" accept=".xls,.xlsx" style="display: none;" @change="handleFileChange" />
</template>

<script setup>
import { ref } from 'vue';
import { useApi } from '@/stores/apiTemplate';

const api = useApi();

const fileInput = ref();
const selectedFile = ref(undefined);
const loading = ref(false);
const loading_log = ref(false);
const showSyncLog = ref(false);
const syncLog = ref('');

function handleFileChange(event) {
    const file = event.target.files[0];
    if (file) {
        selectedFile.value = file;
        api.showSnack(`Файл ${selectedFile.value.name} загружен`, 'success');
    }
}

function addFile() {
    fileInput.value.click();
}

function deleteFile() {
    selectedFile.value = undefined;
}

async function executeSync() {
    if (!selectedFile.value) {
        api.showSnack('Сначала добавьте файл для синхронизации', 'red');
        return;
    }

    loading.value = true;
    showSyncLog.value = true;
    syncLog.value = '';

    const formData = new FormData();
    formData.append('file', selectedFile.value);

    try {
        const response = await fetch('/api/update_data_stream', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            const text = await response.text();
            api.showSnack(text, 'red');
            showSyncLog.value = false;
            return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';

        while (true) {
            const { value, done } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, { stream: true });

            let lines = buffer.split('\n');
            buffer = lines.pop();
            for (const line of lines) {
                if (!line.trim()) continue;
                try {
                    const obj = JSON.parse(line);
                    if (obj.progress) {
                        console.log('Progress:', obj.progress);
                        syncLog.value += obj.progress + '\n';
                    }
                } catch (e) {
                    console.warn('Не удалось распарсить строку:', line);
                }
            }
        }

        if (buffer.trim()) {
            try {
                const obj = JSON.parse(buffer);
                if (obj.progress) {
                    console.log('Progress:', obj.progress);
                    syncLog.value += obj.progress + '\n';
                }
            } catch (e) {
                console.warn('Не удалось распарсить остаток буфера:', buffer);
            }
        }

        api.showSnack('Синхронизация завершена', 'success');
    } catch (err) {
        console.error(err);
        api.showSnack('Ошибка синхронизации', 'red');
        showSyncLog.value = false;
    } finally {
        loading.value = false;
    }
}
async function downloadLog() {
    try {
        loading_log.value = true;
        const response = await api.get_log_today();
        if (!response) return;
        const blob = new Blob([await response.arrayBuffer()], { type: 'text/plain' });
        const link = document.createElement('a');
        const todayStr = new Date().toLocaleDateString('ru-RU').split('.').join('-'); 
        link.href = window.URL.createObjectURL(blob);
        link.download = `${todayStr}.log`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        api.showSnack('Файл логов скачен', 'success');
    } catch (err) {
        console.error(err);
        api.showSnack('Ошибка при скачивании файла логов', 'red');
    } finally {
        loading_log.value = false;
    }
}
</script>

<style scoped>
.v-card-text {
    white-space: pre-wrap;
}
</style>